module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cashbackPartialPaymentTourBanner">\n    <div class="cashbackPartialPaymentTourBanner-cashbackSection">\n        <i class="cashbackPartialPaymentTourBanner-cashbackSection__icon"></i>\n\n        <a class="cashbackPartialPaymentTourBanner-cashbackSection__link"\n           href="'+
((__t=(landingUrl ))==null?'':__t)+
'">'+
((__t=(bannerText ))==null?'':__t)+
'</a>\n    </div>\n\n    <div class="cashbackPartialPaymentTourBanner-partialPaymentSection">\n        <i class="cashbackPartialPaymentTourBanner-partialPaymentSection__icon"></i>\n\n        <div class="cashbackPartialPaymentTourBanner-partialPaymentSection__text">\n            или внесите предоплату 10% от стоимости тура\n        </div>\n\n        <i class="cashbackPartialPaymentTourBanner-partialPaymentSection__questionIcon js-open-hotel-tour-dg"></i>\n    </div>\n</div>\n';
}
return __p;
};
